import PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledFooter = styled.tfoot`
`

const TableFormFooter = ({ children }) => {
  return (
    <StyledFooter>
      <tr>
        <td colSpan='100%'>
          {children}
        </td>
      </tr>
    </StyledFooter>
  )
}

TableFormFooter.propTypes = {
  children: PropTypes.node,
}

export default TableFormFooter
